import {StageLayer} from '@nolimitcity/slot-launcher/bin/StageLayer';
import {gsap} from 'gsap';
import {BLEND_MODES} from 'pixi.js';
import {IDimOrientation, LayoutDimData, ResizeHelper} from '../../../core/utils/ResizeHelper';
import {UniPlayer, UniversalPlayer} from '../../../core/displayobject/UniversalPlayer';
import {MathHelper} from '../../../core/utils/MathHelper';
import {Helper} from '../../../core/utils/Helper';
import {SpinePlayConfig, SpinePlayer} from '../../../core/displayobject/SpinePlayer';
import {ISequencePlay} from '../../../core/displayobject/Sequence';

export class BigWinPosterState {

    //BIGWIN
    public static readonly BIG_WIN_LEVEL_1: string = "BW0";
    public static readonly BIG_WIN_LEVEL_2: string = "BW1";
    public static readonly BIG_WIN_LEVEL_3: string = "BW2";
    public static readonly BIG_WIN_LEVEL_4: string = "BW3";
    public static readonly BIG_WIN_LEVEL_5: string = "BW4";
}

export class PosterManager extends PIXI.Container implements StageLayer {

    public get dim(): LayoutDimData {
        return ResizeHelper.calcDim(this.PosterDim);
    };

    private PosterDim: IDimOrientation = {
        landscape: {
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(360, 360),
        },
        portrait: {
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(360, 220)
        }
    };

    private WIDTH: number = 1440;
    private HEIGHT: number = 900;

    private player: UniversalPlayer;
    private postObj: UniPlayer;

    private transitionSpine: SpinePlayer;

    private blackGraphics: PIXI.Graphics;

    private timeline: gsap.core.Timeline | undefined;
    private timelineBlack: gsap.core.Timeline;

    constructor() {
        super();
        this.initAnimations();
    };

    public gradientColorLvl(lvl: number): string {
        switch (lvl) {
            case 0:
                return "rgb(0,51,255,0.7)";
            case 1:
                return "rgb(44,168,22,0.7)";
            case 2:
                return "rgb(204,0,0,0.7)";
            case 3:
                return "rgb(153,0,255,0.7)";
            default:
                return "rgb(0,0,0,0.7)"
        }
    }

    protected initAnimations(): void {

        this.createGraphics();

        this.player = new UniversalPlayer([BigWinPosterState.BIG_WIN_LEVEL_1,
            BigWinPosterState.BIG_WIN_LEVEL_2, BigWinPosterState.BIG_WIN_LEVEL_3, BigWinPosterState.BIG_WIN_LEVEL_4,
            BigWinPosterState.BIG_WIN_LEVEL_5]);

        this.player.uniPlayers.forEach(p => {
            this.addChild(p.obj);
            p.obj.visible = false;
        });

        this.transitionSpine = this.addChild(new SpinePlayer("BigWin_Tranition")) //animation

        this.onResize();
    }

    public get transitionDuration(): number {
        return this.transitionSpine.fetchDuration("animation");
    }

    public playTransition(): gsap.core.Timeline {
        return this.transitionSpine.play({animation:"animation"});
    }

    public bigWinPresentationDuration(lvlRequest:number): number {
        return SpinePlayer.fetchDuration("BW"+lvlRequest,"animation");
    }

    public playBigWin(lvlRequest: number,durr?:number): gsap.core.Timeline {
        this.timeline = Helper.setTimeline(this.timeline,undefined,true);
        if(this.postObj) this.postObj.stop(true);
        this.postObj = this.player.get("BW" + lvlRequest);
        if (lvlRequest === 0) {
            this.timeline.fromTo([this.postObj.obj,this.blackGraphics], {alpha: 0}, {duration: 0.25, alpha: 1}, 0)
        }
        
        return this.timeline.add(this.postObj.play({animation:"animation",showOnEnd:true, duration:durr, onStart:() => this.postObj.obj.alpha = 1}),0);
    }

    public stop(fadeout: number = 0.2): gsap.core.Timeline {
        let endTl = gsap.timeline({ onComplete:() => {
            this.timeline = Helper.setTimeline(this.timeline,undefined,true);
        }});

        endTl.fromTo([this.postObj.obj], {alpha: 1}, {duration: fadeout, alpha: 0})
        endTl.fromTo([this.blackGraphics], {alpha: 1}, {duration: fadeout*1.5, alpha: 0})
        return endTl.play();
    }

    public setBlackScreenAlpha(to: number, duration: number = 0.3): gsap.core.Timeline {
        this.timelineBlack = Helper.setTimeline(this.timelineBlack, new gsap.core.Timeline());
        this.timelineBlack.to(this.blackGraphics, {duration: duration, alpha: to});
        return this.timelineBlack;
    }

    private createGraphics(): void {
        this.blackGraphics = new PIXI.Graphics();
        this.blackGraphics.alpha = 0;
        this.blackGraphics.interactive = false;
        this.blackGraphics.buttonMode = false;

        this.blackGraphics.beginFill(0x000000, 1);
        this.blackGraphics.drawRect(-this.WIDTH, -this.HEIGHT, this.WIDTH * 2, this.HEIGHT * 2);
        this.blackGraphics.endFill();

        this.addChild(this.blackGraphics);
    }

    onResize() {
        if (this.blackGraphics === undefined) return;

        this.position = this.dim.position;
        this.scale = this.dim.scale;

    }
}
